import { TOOL_NAV_ITEMS } from '@/pages/ipe/workbench/constants/workbenchNavConfig';

/** 详情快捷入库：来源 navId → 本地商品库批次「来源」列展示名 */
const LISTING_BRIDGE_SOURCE_NAV_ALIASES = {
  titles: 'aiCopywriting',
  titleExtract: 'aiCopywriting',
};

/** 模块展示名覆盖（与详情页/工具栏惯用简称一致） */
const LISTING_BRIDGE_SOURCE_LABEL_OVERRIDES = {
  podProductDesign: '商品设计',
  goods_composite: '主图创作',
  podProductDesign_composite: '商品设计',
};

/**
 * @param {string} sourceNavId 详情页功能 navId 或 raw.source 枚举
 * @returns {string}
 */
export function resolveListingBridgeSourceLabel(sourceNavId) {
  const raw = String(sourceNavId || '').trim();
  if (!raw) return '';

  if (LISTING_BRIDGE_SOURCE_LABEL_OVERRIDES[raw]) {
    return LISTING_BRIDGE_SOURCE_LABEL_OVERRIDES[raw];
  }

  const navId = LISTING_BRIDGE_SOURCE_NAV_ALIASES[raw] || raw;
  const fromNav = TOOL_NAV_ITEMS[navId]?.label;
  if (fromNav) return fromNav;

  return '';
}

function readRawFieldFromSnippet(item, field) {
  const snippet = String(item?.rawJsonSnippet || item?.raw_json_snippet || '').trim();
  if (!snippet) return '';
  try {
    const parsed = JSON.parse(snippet);
    const value = parsed?.[field];
    return value != null ? String(value).trim() : '';
  } catch {
    const escaped = field.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const m = snippet.match(new RegExp(`"${escaped}"\\s*:\\s*"([^"]+)"`));
    return m?.[1] ? String(m[1]).trim() : '';
  }
}

function readListingTextSourceNavId(item) {
  const text = String(item?.listingText || item?.listing_text || '').trim();
  const m = text.match(/来源[：:]\s*([^\s；;]+)/);
  if (!m?.[1]) return '';
  const token = m[1].trim();
  if (!token || token === '详情页') return '';
  return token;
}

function readSourceNavIdFromItem(item) {
  if (!item || typeof item !== 'object') return '';
  const direct = String(item?.raw?.sourceNavId || item?.sourceNavId || '').trim();
  if (direct) return direct;

  const fromSnippet = readRawFieldFromSnippet(item, 'sourceNavId');
  if (fromSnippet) return fromSnippet;

  const fromListingText = readListingTextSourceNavId(item);
  if (fromListingText) return fromListingText;

  return '';
}

function readRawSourceFromItem(item) {
  if (!item || typeof item !== 'object') return '';
  const direct = String(item?.raw?.source || item?.source || '').trim();
  if (direct) return direct;
  return readRawFieldFromSnippet(item, 'source');
}

/**
 * 从商品库条目解析快捷入库来源 navId / raw.source。
 * @param {object} item
 * @returns {string}
 */
export function resolveListingBridgeSourceNavIdFromItem(item) {
  return readSourceNavIdFromItem(item) || readRawSourceFromItem(item);
}

/**
 * 从商品库条目 raw 解析快捷入库来源模块名。
 * @param {object} item
 * @returns {string}
 */
export function resolveListingBridgeSourceLabelFromItem(item) {
  const navId = readSourceNavIdFromItem(item);
  if (navId) {
    const label = resolveListingBridgeSourceLabel(navId);
    if (label) return label;
  }
  return resolveListingBridgeSourceLabel(readRawSourceFromItem(item));
}
